import { TApiResponse } from '@/common/types/response';

import { TAnalyticsNotesCountryDeclensionsResponse } from '../../types/analytics-notes';
import { TAnalyticsNotesCommonState } from './types';

export function setCountryDeclensions(
  state: TAnalyticsNotesCommonState,
  response: TApiResponse<TAnalyticsNotesCountryDeclensionsResponse>,
) {
  const data = response.data;

  state.countryDeclensions = {
    countryInGenitive: data.genitive ?? '',
    countryInAccusative: data.accusative ?? '',
    countryInInstrumental: data.instrumental ?? '',
  };
}
